module.exports = __webpack_public_path__ + "media/images/emails/youtube-d4500b425a3c57f835859e029d964d03.png";